module.exports = __webpack_public_path__ + "static/img/social-mobility.dbc0564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/research-page/social-mobility.png
// module id = pFfp
// module chunks = 0